import { createSlice } from "@reduxjs/toolkit";


//INITIAL STATE
const initialState ={
    troublesViewForQuize: false,
    selectedNoteId: '',
    selectedPart: '',
    viewInputFormsForTroubles: false,
    viewDeleteInputFormsForAnswerTrouble : false, 
    viewDeleteInputFormsForTrouble : false,
    answerTroubleRates:[], 
    
};

const options = {
    name: 'troubles',
    initialState: {
        troublesViewForQuize: false,
        selectedNoteId: '',
        selectedPart: '',
        viewInputFormsForTroubles: false,
        viewAnswerForTroubles: false,
        viewDeleteInputFormsForAnswerTrouble : false,
        viewDeleteInputFormsForTrouble : false,
        answerTroubleRates:[],
        
    },

reducers: {
    getInitialState: state  => 
    initialState,

    openTroublesFormForQuiz: (state) => {
    state.troublesViewForQuize = !state.troublesViewForQuize;
},
    setSelectedTroubles: (state, action) => {
        state.selectedNoteId = action.payload.selectedNoteId;
        state.selectedPart = action.payload.selectedPart;
    },
    setViewInputFormsForTroubles: (state) => {
        state.viewInputFormsForTroubles = !state.viewInputFormsForTroubles;
    },
    closeViewInputFormsForTroubles: (state) => {
        state.viewInputFormsForTroubles = false;
    },
    setViewAnswerForTroubles: (state) => {
        state.viewAnswerForTroubles = !state.viewAnswerForTroubles;
    },
    closeViewIAnswerForTroubles: (state) => {
        state.viewAnswerForTroubles = false;
    },
    closeDeleteInputFormsForAnswerTrouble: (state) => {
        state.viewDeleteInputFormsForAnswerTrouble= false;
    },
    openViewDeleteInputFormsForAnswerTrouble: (state, action) => {
        state.viewDeleteInputFormsForAnswerTrouble= true;
        
    },
    closeDeleteInputFormsForTrouble: (state) => {
        state.viewDeleteInputFormsForTrouble= false;
    },
    openViewDeleteInputFormsForTrouble: (state, action) => {
        state.viewDeleteInputFormsForTrouble= true;
        
    },
    setAnswerTroubleRate: (state, action) => {

        state.answerTroubleRates.push(action.payload);
   
    }, 
    changeAnswerTroubleRate: (state, action) => {

        state.answerTroubleRates[action.payload].valueRate = !state.answerTroubleRates[action.payload].valueRate;
   
    },      
   
},
/*
extraReducers(builder) {
           builder
            

}

*/        

};

export const  troubleSlice = createSlice(options);
export const {openTroublesFormForQuiz, setSelectedTroubles, setViewInputFormsForTroubles,
    closeViewInputFormsForTroubles, setViewAnswerForTroubles, closeViewIAnswerForTroubles,
    closeDeleteInputFormsForAnswerTrouble, openViewDeleteInputFormsForAnswerTrouble, closeDeleteInputFormsForTrouble,
    openViewDeleteInputFormsForTrouble, setAnswerTroubleRate, changeAnswerTroubleRate
} = troubleSlice.actions;
export default troubleSlice.reducer;


